import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { sessionEnded } from '../slices/sessionActions';
import { markDeliberateSignOut } from '../apiTools/apiClient';
import { AuthStdFooter } from "../utils/auth-std-footer";
export default function Logout() {
  const dispatch = useDispatch();

  useEffect(() => {

    // ⭐ EMPTY THE WHOLE STORE, not one slice of it.
    //
    // Redux state is cleared by a full page load, which the redirect below now is. Belt and
    // braces: this ran for years behind a ROUTER navigation that cleared nothing, so the reset
    // stays whatever the redirect does.
    //
    // ⛔ This used to clear only `resetDirectAssets` (LitGroups/Books/Characters), written for
    // one observed leak in the Rendering Studio's picker. Measured 2026-08-31: that was the ONLY
    // slice cleared, of 22+ — and a Voice Actor was shown the Book Creator's Opportunities
    // Marketplace search AND its results, because the opportunity slice had no reset and nothing
    // dispatched one. Per-slice cleanup had already fallen a slice behind; the root reset in
    // utils/store.js covers every slice, including ones added after this comment.
    /**
     * ⭐ MARKED FIRST, BEFORE ANYTHING IS CLEARED. Two things read this marker and both need it in
     * place before the token goes: the login page, so it does not try to explain a sign-out you
     * chose, and the token write audit, so it does not raise its downgrade alarm for a live token
     * that was removed on purpose.
     */
    markDeliberateSignOut();

    dispatch(sessionEnded());

    // removeItem, NOT setItem(..., null). localStorage stores strings, so setting null wrote the
    // literal "null" — which is truthy, so the request interceptor kept attaching
    // `Authorization: Bearer null` to every call and the server answered 401 forever. Logging out
    // left the session in exactly the broken state logging out is meant to clear.
    localStorage.removeItem('authToken');

    /**
     * ⭐ A FULL LOAD TO /login, NOT A ROUTER NAVIGATION (2026-10-25).
     *
     * The eject path in apiClient.js has always used window.location.assign, and logging out
     * used navigate() — so the two ways of ending a session behaved differently. A password
     * manager offers saved credentials when it believes the form was newly created, which a
     * document load guarantees and an SPA route change does not: autofill fired after an
     * expiry eject and never after a logout. The operator had learned to read the difference
     * ("when that happens I know the login is going to work") without knowing what it meant.
     *
     * ⓘ And /login, not / — ending a session should land on the form, and the WhySignedOut
     * panel there is the one place a recent 401 breadcrumb gets shown.
     */
    /**
     * ⓘ The deliberate-sign-out marker is set at the TOP of this effect, not here. Everything
     * above empties a session, and emptying one is indistinguishable from losing one by the time
     * /login renders — the token is gone either way. Without the marker, WhySignedOut reads
     * whatever 401 happened to be newest and presents it as the reason, which on 2026-10-26 was a
     * bare `/login-allowlist/me` from the navbar badge, racing this very effect.
     */
    window.location.assign('/login');

  }, [dispatch]);
}
